'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var EventEmitter = require('events');

var Big = require('bignumber.js');

var MovingAverage = require('moving-average');

var retimer = require('retimer');
/**
 * A queue based manager for stat processing
 *
 * @param {Array<string>} initialCounters
 * @param {any} options
 */


var Stats = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Stats, _EventEmitter);

  var _super = _createSuper(Stats);

  function Stats(initialCounters, options) {
    var _this;

    _classCallCheck(this, Stats);

    _this = _super.call(this);
    _this._options = options;
    _this._queue = [];
    _this._stats = {};
    _this._frequencyLastTime = Date.now();
    _this._frequencyAccumulators = {};
    _this._movingAverages = {};
    _this._update = _this._update.bind(_assertThisInitialized(_this));
    var intervals = _this._options.movingAverageIntervals;

    for (var i = 0; i < initialCounters.length; i++) {
      var key = initialCounters[i];
      _this._stats[key] = Big(0);
      _this._movingAverages[key] = {};

      for (var k = 0; k < intervals.length; k++) {
        var interval = intervals[k];
        var ma = _this._movingAverages[key][interval] = MovingAverage(interval);
        ma.push(_this._frequencyLastTime, 0);
      }
    }

    return _this;
  }
  /**
   * Initializes the internal timer if there are items in the queue. This
   * should only need to be called if `Stats.stop` was previously called, as
   * `Stats.push` will also start the processing.
   *
   * @returns {void}
   */


  _createClass(Stats, [{
    key: "start",
    value: function start() {
      if (this._queue.length) {
        this._resetComputeTimeout();
      }
    }
    /**
     * Stops processing and computing of stats by clearing the internal
     * timer.
     *
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function stop() {
      if (this._timeout) {
        this._timeout.clear();

        this._timeout = null;
      }
    }
    /**
     * Returns a clone of the current stats.
     *
     * @returns {Map<string, Stat>}
     */

  }, {
    key: "snapshot",
    get: function get() {
      return Object.assign({}, this._stats);
    }
    /**
     * Returns a clone of the internal movingAverages
     *
     * @returns {Array<MovingAverage>}
     */

  }, {
    key: "movingAverages",
    get: function get() {
      return Object.assign({}, this._movingAverages);
    }
    /**
     * Returns a plain JSON object of the stats
     *
     * @returns {*}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var snapshot = this.snapshot;
      var movingAverages = this.movingAverages;
      var data = {
        dataReceived: snapshot.dataReceived.toString(),
        dataSent: snapshot.dataSent.toString(),
        movingAverages: {}
      };
      var counters = Object.keys(movingAverages);

      for (var _i = 0, _counters = counters; _i < _counters.length; _i++) {
        var key = _counters[_i];
        data.movingAverages[key] = {};

        for (var _i2 = 0, _Object$keys = Object.keys(movingAverages[key]); _i2 < _Object$keys.length; _i2++) {
          var interval = _Object$keys[_i2];
          data.movingAverages[key][interval] = movingAverages[key][interval].movingAverage();
        }
      }

      return data;
    }
    /**
     * Pushes the given operation data to the queue, along with the
     * current Timestamp, then resets the update timer.
     *
     * @param {string} counter
     * @param {number} inc
     * @returns {void}
     */

  }, {
    key: "push",
    value: function push(counter, inc) {
      this._queue.push([counter, inc, Date.now()]);

      this._resetComputeTimeout();
    }
    /**
     * Resets the timeout for triggering updates.
     *
     * @private
     * @returns {void}
     */

  }, {
    key: "_resetComputeTimeout",
    value: function _resetComputeTimeout() {
      if (this._timeout) {
        this._timeout.reschedule(this._nextTimeout());
      } else {
        this._timeout = retimer(this._update, this._nextTimeout());
      }
    }
    /**
     * Calculates and returns the timeout for the next update based on
     * the urgency of the update.
     *
     * @private
     * @returns {number}
     */

  }, {
    key: "_nextTimeout",
    value: function _nextTimeout() {
      // calculate the need for an update, depending on the queue length
      var urgency = this._queue.length / this._options.computeThrottleMaxQueueSize;
      var timeout = Math.max(this._options.computeThrottleTimeout * (1 - urgency), 0);
      return timeout;
    }
    /**
     * If there are items in the queue, they will will be processed and
     * the frequency for all items will be updated based on the Timestamp
     * of the last item in the queue. The `update` event will also be emitted
     * with the latest stats.
     *
     * If there are no items in the queue, no action is taken.
     *
     * @private
     * @returns {void}
     */

  }, {
    key: "_update",
    value: function _update() {
      this._timeout = null;

      if (this._queue.length) {
        var last;

        var _iterator = _createForOfIteratorHelper(this._queue),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            last = _step.value;

            this._applyOp(last);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this._queue = [];

        this._updateFrequency(last[2]); // contains timestamp of last op


        this.emit('update', this._stats);
      }
    }
    /**
     * For each key in the stats, the frequency and moving averages
     * will be updated via Stats._updateFrequencyFor based on the time
     * difference between calls to this method.
     *
     * @private
     * @param {Timestamp} latestTime
     * @returns {void}
     */

  }, {
    key: "_updateFrequency",
    value: function _updateFrequency(latestTime) {
      var _this2 = this;

      var timeDiff = latestTime - this._frequencyLastTime;
      Object.keys(this._stats).forEach(function (key) {
        _this2._updateFrequencyFor(key, timeDiff, latestTime);
      });
      this._frequencyLastTime = latestTime;
    }
    /**
     * Updates the `movingAverages` for the given `key` and also
     * resets the `frequencyAccumulator` for the `key`.
     *
     * @private
     * @param {string} key
     * @param {number} timeDiffMS Time in milliseconds
     * @param {Timestamp} latestTime Time in ticks
     * @returns {void}
     */

  }, {
    key: "_updateFrequencyFor",
    value: function _updateFrequencyFor(key, timeDiffMS, latestTime) {
      var count = this._frequencyAccumulators[key] || 0;
      this._frequencyAccumulators[key] = 0; // if `timeDiff` is zero, `hz` becomes Infinity, so we fallback to 1ms

      var safeTimeDiff = timeDiffMS || 1;
      var hz = count / safeTimeDiff * 1000;
      var movingAverages = this._movingAverages[key];

      if (!movingAverages) {
        movingAverages = this._movingAverages[key] = {};
      }

      var intervals = this._options.movingAverageIntervals;

      for (var i = 0; i < intervals.length; i++) {
        var movingAverageInterval = intervals[i];
        var movingAverage = movingAverages[movingAverageInterval];

        if (!movingAverage) {
          movingAverage = movingAverages[movingAverageInterval] = MovingAverage(movingAverageInterval);
        }

        movingAverage.push(latestTime, hz);
      }
    }
    /**
     * For the given operation, `op`, the stats and `frequencyAccumulator`
     * will be updated or initialized if they don't already exist.
     *
     * @private
     * @param {Array<string, number>} op
     * @throws {InvalidNumber}
     * @returns {void}
     */

  }, {
    key: "_applyOp",
    value: function _applyOp(op) {
      var key = op[0];
      var inc = op[1];

      if (typeof inc !== 'number') {
        throw new Error('invalid increment number:', inc);
      }

      var n;

      if (!Object.prototype.hasOwnProperty.call(this._stats, key)) {
        n = this._stats[key] = Big(0);
      } else {
        n = this._stats[key];
      }

      this._stats[key] = n.plus(inc);

      if (!this._frequencyAccumulators[key]) {
        this._frequencyAccumulators[key] = 0;
      }

      this._frequencyAccumulators[key] += inc;
    }
  }]);

  return Stats;
}(EventEmitter);

module.exports = Stats;